import { React } from 'Imports';
import { Route } from 'react-router-dom';
import { PageTitleSetter } from '../utils/usePageTitleSetter';
import { VerifyRole } from '$Externals/VerifyRole';
import { findGeotabRoute } from './geotab-route-config';
import { GeotabManager } from 'integrationPartner/geotabManager';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

const GeotabRouteRenderer = () => {
    const location = useLocation();

    const baseRoutePath = useMemo(() => {
        const hash = (location.hash || '').replace(/^#/, '');
        return hash.split(',')[0];
    }, [location.hash]);

    const { label, Component, allowedRoles } = useMemo(
        () => findGeotabRoute(location.hash),
        [baseRoutePath]
    );

    return (
        <PageTitleSetter title={label}>
            {allowedRoles.length > 0 ? (
                <VerifyRole allowedRole={allowedRoles} restrictedMessage={true}>
                    <Component key={baseRoutePath} />
                </VerifyRole>
            ) : (
                <Component key={baseRoutePath} />
            )}
        </PageTitleSetter>
    );
};

const GeoTabIntegratedRoutes = () => {
    return (
        <Route
            path={'/' + GeotabManager.getGeotabUserCredentialsDatabase()}
            element={<GeotabRouteRenderer />}
        />
    );
};

export { GeoTabIntegratedRoutes };
